import axios from "axios";
import keycloak from "authentication/keycloak";

const setAuthToken = () => {
  const reqInterceptor = axios.interceptors.request.use(async (config) => {
    if (process.env.NODE_ENV === "test") {
      return config;
    } else {
      if (!keycloak.authenticated) {
        keycloak.init({ onLoad: "login-required" });
      }

      const token = keycloak.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        console.error("Failed to acquire token");
      }
    }
    return config;
  });

  return { reqInterceptor };
};

export default setAuthToken;
